import './helpers';

import Timer from './timer';
import Notifier from './notifier';
import {UserStatus, MessageStyle} from '@iassasin/wschatapi';
import {preprocessMessage, preprocessSysMessage} from './messagepreprocessor';
import Settings from './settings';

export default class Room {
	constructor(chat, wsroom){
		this.chat = chat;
		this.wsroom = wsroom;
		this.unread = 0;
		this.messages = [];
		this.typing = [];
		this.lastPM = null;
		this.joined = false;

		this.timerTyping = new Timer(() => {
			this.sendTyping(false);
		});
	}

	makeSysMessage(msg){
		return {
			type: 'sysmessage',
			time: Date.now(),
			body: msg,
		};
	}

	onSysMessage(message){
		this.addMessage(this.makeSysMessage(message));
	}

	onMessage(dt){
		//let arr = ['aquamarine', 'steelblue', 'skyblue', 'sandybrown', 'powderblue'];
		//let arr = ['chartreuse', 'cornflowerblue', 'darkcyan', 'cyan', 'deepskyblue', 'dodgerblue', 'greenyellow'];
		let msg = {
			id: dt.id,
			time: dt.time*1000,
			from: {
				id: dt.from,
				nick: dt.from_login,
				color: dt.color,
			},
			body: dt.message,
		};

		if (dt.to != 0){
			let mto = this.wsroom.getMemberById(dt.to);

			msg.type = 'message_private';
			msg.to = {
				id: dt.to,
				nick: mto.name,
				color: mto.color,
			};

			if (dt.from != this.wsroom.memberId){
				this.lastPM = dt.from;
			}
		}
		else if (dt.style == MessageStyle.message || dt.style == MessageStyle.offtop){
			let prevmsg = this.messages[this.messages.length - 1];

			msg.type = dt.style == MessageStyle.message ? 'message' : 'message_offtop';
			msg.continuous = prevmsg && (prevmsg.type == 'message' || prevmsg.type == 'message_offtop') && prevmsg.from.id == dt.from;
		}
		else if (dt.style == MessageStyle.me){
			msg.type = 'message_me';
		}
		else if (dt.style == MessageStyle.event){
			msg.type = 'message_event';
		}

		if (this.isMessageAlreadyInList(msg)) {
			return;
		}

		this.addMessage(msg);

		if (this.wsroom.memberNick != '' && dt.message.indexOf('@' + this.wsroom.memberNick) != -1) {
			Notifier.mention(this.wsroom.target, dt.from_login, dt.message);
		} else {
			Notifier.message(this.wsroom.target, dt.from_login, dt.message);
		}
	}

	isMessageAlreadyInList(msg) {
		for (let i = this.messages.length - 1; i >= 0; --i) {
			let exMsg = this.messages[i];

			if (msg.time > exMsg.time) {
				return false;
			}

			if (typeof msg.id === 'string' && msg.id === exMsg.id) {
				return true;
			}
		}

		return false;
	}

	onJoined() {
		this.joined = true;
	}

	onLeave() {
		if (this.joined) {
			this.addMessage(this.makeSysMessage('Вы отключились от комнаты'));
		}

		this.joined = false;
	}

	onUserStatusChanged(dt){
		dt.old_name = dt.data;
		let msg = {
			time: Date.now(),
			user: dt,
		};

		switch (dt.status){
			case UserStatus.bad:
				this.addMessage(this.makeSysMessage('Bad userstatus. WTF???'));
				break;

			case UserStatus.online:
				if (dt.member_id != this.wsroom.memberId) {
					if (Settings.statusMessages) {
						msg.type = 'status_online';
						this.addMessage(msg);
						Notifier.online(this.wsroom.target, dt.name, dt.girl ? 'пришла в комнату' : 'пришел в комнату');
					}
				} else {
					this.addMessage(this.makeSysMessage('Вы пришли в комнату'));
				}
				break;

			case UserStatus.offline:
				if (dt.member_id != this.wsroom.memberId) {
					if (Settings.statusMessages) {
						msg.type = 'status_offline';
						this.addMessage(msg);
					}
				} else {
					this.addMessage(this.makeSysMessage('Вы покинули комнату'));
				}
				this.updateTypingList();
				break;

			case UserStatus.nick_change:
				msg.type = 'status_change_nick';
				this.addMessage(msg);
				break;

			case UserStatus.gender_change:
				if (dt.name == ''){
					this.addMessage(this.makeSysMessage('Вы сменили пол на ' + (dt.girl ? 'женский' : 'мужской')));
				} else {
					msg.type = 'status_change_gender';
					this.addMessage(msg);
				}
				break;

			case UserStatus.color_change:
				msg.type = 'status_change_color';
				this.addMessage(msg);
				break;

			case UserStatus.typing:
			case UserStatus.stop_typing:
				this.updateTypingList();
				break;
		}

		this.chat.onOnlineListChanged(this, this.wsroom.members);
	}

	addMessage(msg){
		if ('body' in msg){
			if (msg.type == 'sysmessage' || msg.type.substr(0, 7) == 'status_'){
				msg.processedBody = preprocessSysMessage(msg.body, this);
			} else {
				msg.processedBody = preprocessMessage(msg.body, this);
			}
		}

		this.messages.push(msg);
		this.chat.onChatMessage(this, msg);
	}

	clearMessages(){
		this.messages = [];
	}

	getMembers() {
		return this.wsroom.members;
	}

	getMessages(){
		return this.messages;
	}

	getTypingMembers(){
		return this.typing;
	}

	setTyping(val){
		if (val){
			if (!this.timerTyping.isStarted()){
				this.sendTyping(true);
			}
			this.timerTyping.start(5000);
		} else {
			this.timerTyping.stop();
			this.sendTyping(false);
		}
	}

	sendTyping(val) {
		if (this.wsroom.memberNick != '') {
			this.wsroom.changeStatus(val ? UserStatus.typing : UserStatus.stop_typing);
		}
	}

	updateTypingList() {
		let list = [];
		let members = this.wsroom.members;
		for (let i in members) {
			if (members[i].typing && members[i].member_id != this.wsroom.memberId) {
				list.push(members[i]);
			}
		}
		this.typing = list;
		this.chat.onTypingListChanged(this, this.typing);
	}

	getLastPMMemberId(){
		return this.lastPM;
	}
}
